module.exports = "pegasus_template/assets/blocks/column-15-theme3.png";